import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Children } from 'react';
import PropTypes from 'prop-types';
import { StyledGridList, StyledGridListItem } from './GridList.style.js';

const GridList = _ref => {
  let {
    children,
    className,
    gap,
    justifyContent,
    lg,
    md,
    noMargin,
    sm,
    xl,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledGridList, _extends({
    $gap: gap,
    $justifyContent: justifyContent,
    $noMargin: noMargin,
    className: className
  }, rest), Children.map(children, child => (child || child === 0) && /*#__PURE__*/React__default.createElement(StyledGridListItem, {
    $gap: gap,
    $lg: lg,
    $md: md,
    $sm: sm,
    $xl: xl
  }, child)));
};
GridList.displayName = 'GridList';
GridList.propTypes = {
  /**
   * Content of the component.
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gap: PropTypes.oneOf(['sm', 'lg', 'xl']),
  justifyContent: PropTypes.oneOf(['center']),
  lg: PropTypes.oneOf([1, 2, 3, 4]),
  md: PropTypes.oneOf([1, 2, 3, 4]),
  /**
   * Disable default bottom margin.
   */
  noMargin: PropTypes.bool,
  sm: PropTypes.oneOf([1, 2, 3, 4]),
  xl: PropTypes.oneOf([1, 2, 3, 4])
};

export { GridList };
